import { Location } from 'history'

export function getParentPath(location: Location) {
  let breadCrumbs = location.pathname.split("/");
  breadCrumbs.pop();
  const parentPath = breadCrumbs.join('/');
  return parentPath ? parentPath : '/';
}

export function canGoBack() {
  return (window as any).navigationHistory && (window as any).navigationHistory.length > 0;
}